import { render, staticRenderFns } from "./StudentProfileDashboard.vue?vue&type=template&id=fabf6220&scoped=true&"
import script from "./StudentProfileDashboard.vue?vue&type=script&lang=js&"
export * from "./StudentProfileDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileDashboard.vue?vue&type=style&index=0&id=fabf6220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf6220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAutocomplete,VBtn,VCol,VContainer,VRow,VSkeletonLoader,VSnackbar})
